import customDialog from './components/dialog.vue';
export default customDialog;
